<!-- added by Samikchha Kumar on 25-Mar-2023 -->
<div class="container">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top: 10px;">
          <div class="panel panel-default" id="panel4" style="margin-bottom: 0px !important;">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a>
                  <b>{{LabelName}}</b>
                </a>
              </h4>
            </div>
          </div>
        <!-- Buttons -->
        <div class="row" id="divTop" style="margin-bottom: 10px;">
          <div class="col-md-9 col-lg-9 col-sm-9">
            <div id="ButtonsTab">
              <button id="btnGetResult" type="button" title="Get Result" class="btn btn-primary" (click)="GetSearchResult();">
                <span class="hidden-xs" style="width: 85px;">Get Result</span>
              </button>
              <button id="btnReset" type="button" title="Reset" class="btn btn-primary" (click)="ResetResult();">
                <span style="width: 85px;">Reset</span>
              </button>
              <button id="btnExport" type="button" title="Export" (click)="ExportToExcel();" class="btn btn-primary">
                <span class="hidden-xs" style="width: 85px;">Export</span>
              </button>
              <button id="btnExit" type="button" title="Exit" class="btn btn-primary" (click)="onExit();">
                <span class="hidden-xs" style="width: 85px;">Exit</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="ErrorMessage.length > 0">
          <div class="col-md-12">
            <div style="font-size:small;">
              <img src="assets/img/error_icon.gif" /><span class="text-error" style="font-weight:bold;color:red;">The
                following errors were encountered on the page.</span>
            </div>
            <div id="divMainError" class="text-error"
              style="padding-top:0px; margin-bottom:10px;margin-left:25px; font-size:small; color:red">
              <span style="display:list-item" *ngFor="let item of ErrorMessage">{{item.message}}</span>
            </div>
          </div>
        </div>
        <!-- Search Criteria -->
        <div class="accordion">
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                <b>Search Criteria &nbsp;&nbsp; (Click (+/-) to view the Search Parameters)</b>
              </button>
            </h2>
            <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="row pb-2">
                      <div class="col-sm-4" >Employee Code/LPN</div>
                      <div class="col-sm-8">
                        <div class="form-group">
                            <p-autoComplete [(ngModel)]="EmployeeCodeList.EmployeeCode" [suggestions]="filteredEmployeeSingle" autocomplete="off"
                            (completeMethod)="GetEmpCodeSearch($event)" field="EmpGPN" [size]="30"
                            placeholder="Enter Employee Code for Search" [minLength]="3" aria-describedby="basic-addon3"
                            name="EmployeeCode" (onClear)="OnClearCode()" (onSelect)="SetSelectedCode($event)"
                            [forceSelection]="true" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}" [inputStyle]="{'width':'100%'}"></p-autoComplete>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row pb-2">
                      <div class="col-sm-4">
                        Reporting Manager
                      </div>
                      <div class="col-sm-8">
                        <div class="form-group">
                          <p-autoComplete [(ngModel)]="ManagerList.Manager" [suggestions]="filteredManagerSingle" autocomplete="off"
                      (completeMethod)="GetRepManagerSearch($event)" field="EmpFullName" [size]="30"
                      placeholder="Enter Reporting Manager for Search" [minLength]="3" aria-describedby="basic-addon3"
                      name="Manager" (onClear)="OnClearRepManager()" (onSelect)="SetSelectedRepManager($event)"
                      [forceSelection]="true" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}" [inputStyle]="{'width':'100%'}"></p-autoComplete>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="row pb-2">
                      <div class="col-sm-4">
                        <span class="col-sm-4">Employee Name</span>
                      </div>
                      <div class="col-sm-8">
                        <div class="form-group">
                            <p-autoComplete [(ngModel)]="EmployeeList.Employee" [suggestions]="filteredEmployeeSingle" autocomplete="off"
                            (completeMethod)="GetEmpNameSearch($event)" field="EmpFullName" [size]="30"
                            placeholder="Enter Name for Search" [minLength]="3" aria-describedby="basic-addon3"
                            name="Employee" (onClear)="OnClearSendUser()" (onSelect)="SetSelectedEmpGPN($event)"
                            [forceSelection]="true" [style]="{'width':'100%', 'height':'40px', 'font-size': '14px'}" [inputStyle]="{'width':'100%'}"></p-autoComplete>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row pb-2">
                      <div class="col-sm-4">Engagement Code</div>
                      <div class=" col-sm-8">
                        <div class="form-group">
                          <p-autoComplete [(ngModel)]="EngagementList.EngCode" [suggestions]="filteredEngagementSingle" autocomplete="off"
                          (completeMethod)="GetEngCodeSearch($event)" field="UpdatedEngagementCode" [size]="30"
                          placeholder="Enter Name for Search" [minLength]="3" aria-describedby="basic-addon3"
                          name="EngCode" (onClear)="OnClearEngagement()" (onSelect)="SetSelectedEngCode($event)"
                          [forceSelection]="true" [style]="{'width':'100%', 'height':'40px', 'font-size': '14px'}" [inputStyle]="{'width':'100%'}"></p-autoComplete>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="row pb-2">
                      <span class="col-sm-4" >Client Name</span>
                      <div class=" col-sm-8">
                        <div class="form-group">
                          <p-autoComplete [(ngModel)]="ClientList.Client" [suggestions]="filteredClientSingle" autocomplete="off"
                        (completeMethod)="GetClientNameSearch($event)" field="EngClientName" [size]="30"
                        placeholder="Enter Name for Search" [minLength]="3" aria-describedby="basic-addon3"
                        name="Client" (onClear)="OnClearClient()" (onSelect)="SetSelectedClientGPN($event)"
                        [forceSelection]="true" [style]="{'width':'100%', 'height':'40px', 'font-size': '14px'}" [inputStyle]="{'width':'100%'}"></p-autoComplete>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="panel-group">
              <div class="panel panel-default" id="panel1">
                <div class="panel-heading d-flex align-items-center justify-content-between">
                  <h4 class="panel-title">
                    <a>
                      <b>View Records</b>
                    </a>
                  </h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-12" style="width: 100%;">
                      <table id="table1" class="dataTable table table-striped1">
                        <thead>
                          <tr>
                            <th>Emp Code</th>
                            <th>Emp LPN</th>
                            <th>Employee Name</th>
                            <th>Service Line</th>
                            <th>Title</th>
                            <th>Location</th>
                            <th>DOJ</th>
                            <th>Reporting Manager</th>
                            <th>Engagement Code</th>
                            <th>Client Name</th>
                            <th *ngIf="this.ParamID == 4">LWD Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of ViewFTERecordsList; let i = index;">

                            <td>{{item.EmpGPN}}</td>
                            <td><a (click)="onFTERecordClick(item.IDEncrypt)">{{item.EmpLPN}}</a></td>
                            <td>{{item.EmpName}}</td>
                            <td>{{item.EmpSERVICELINE}}</td>
                            <td>{{item.EmpTitle}}</td>
                            <td>{{item.EmpLocation}}</td>
                            <td>{{item.EmpJoiningdate|date: 'dd/MM/yyyy'}}</td>
                            <td>{{item.EmpManagerName}}</td>
                            <td>{{item.Code}}</td>
                            <td>{{item.Client}}</td>
                            <td *ngIf="this.ParamID == 4">{{item.EMPLWD |date: 'dd/MM/yyyy'}}</td>
                          </tr>
                          <tr *ngIf="ViewFTERecordsList==null || ViewFTERecordsList.length==0">
                            <td colspan="15" style="text-align: center;color: red;">Record not found.</td>
                          </tr>
                        </tbody>
                      </table>
                      <ul class="pagination" *ngIf='(ViewFTERecordsList?.length||0)>0'>
                        <li class="page-item">
                          <button class="page-link" (click)="firstPage()"
                                  *ngIf="FTERecordsList.currentPage > 1">
                            First
                          </button>
                        </li>
                        <li class="page-item">
                          <button class="page-link" (click)="PreviousPage()" *ngIf="FTERecordsList.currentPage > 1">
                          </button>
                        </li>
                        <li *ngFor="let n of range(FTERecordsList.TotalPageCount)" class="page-item">
                          <button class="page-link" (click)="setPage(n+1)" [innerHtml]="n+1">{{n+1}}</button>
                        </li>
                        <li class="page-item" *ngIf="FTERecordsList.currentPage < FTERecordsList.TotalPageCount">
                          <!-- || FTERecordsList.TopRecord >= FTERecordsList.TotalRecord -->
                          <button class="page-link" (click)="NextPage()">>></button>
                        </li>
                        <li class="page-item" *ngIf="FTERecordsList.currentPage < FTERecordsList.TotalPageCount">
                          <!-- || FTERecordsList.TopRecord >= FTERecordsList.TotalRecord -->
                          <button class="page-link" (click)="lastPage()">Last</button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
<!-- END by Samikchha Kumar on 25-Mar-2023 -->
